import { apiSlice } from "./apiSlice";
import { NOTIFICATION_MESSAGE_URL } from "../../constants/urls";
import { NAVBAR_NOTIFICATION_QUERY } from "../../utils/notificationHelpers";

const buildNotificationQueryString = (params) => {
  const p = params || {};
  const search = new URLSearchParams();
  if (p.page != null) search.set("page", String(p.page));
  if (p.pageSize != null) search.set("pageSize", String(p.pageSize));
  if (p.isRead === true || p.isRead === false) {
    search.set("isRead", String(p.isRead));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

const getNotificationItems = (draft) => {
  if (Array.isArray(draft?.data)) return draft.data;
  if (Array.isArray(draft?.Data)) return draft.Data;
  return null;
};

const setNotificationItems = (draft, items) => {
  if (Array.isArray(draft?.data)) {
    draft.data = items;
  } else if (Array.isArray(draft?.Data)) {
    draft.Data = items;
  }
};

const findUnreadItemIndex = (items, id) =>
  items.findIndex(
    (item) =>
      item.id === id ||
      item?.data?.notificationId === id ||
      item?.data?.NotificationId === id
  );

const patchUnreadNavbarList = (dispatch, updater) =>
  dispatch(
    apiSlice.util.updateQueryData("getNotification", NAVBAR_NOTIFICATION_QUERY, (draft) => {
      const items = getNotificationItems(draft);
      if (!items) return;
      updater(items);
      setNotificationItems(draft, items);
    })
  );

export const NotificationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotification: builder.query({
      query: (params) => ({
        url: `${NOTIFICATION_MESSAGE_URL}${buildNotificationQueryString(params)}`,
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...(Array.isArray(result?.data)
                ? result.data.map((item) => ({ type: "Notification", id: item.id }))
                : Array.isArray(result)
                  ? result.map((item) => ({ type: "Notification", id: item.id }))
                  : []),
              { type: "Notification", id: "LIST" },
            ]
          : [{ type: "Notification", id: "LIST" }],
    }),
    removeNotification: builder.mutation({
      query: (id) => ({
        url: `${NOTIFICATION_MESSAGE_URL}/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patch = patchUnreadNavbarList(dispatch, (items) => {
          const index = findUnreadItemIndex(items, id);
          if (index >= 0) items.splice(index, 1);
        });
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: [{ type: "Notification", id: "LIST" }],
    }),
    removeAllNotifications: builder.mutation({
      query: () => ({
        url: `${NOTIFICATION_MESSAGE_URL}/all`,
        method: "DELETE",
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const patch = patchUnreadNavbarList(dispatch, (items) => {
          items.splice(0, items.length);
        });
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: [{ type: "Notification", id: "LIST" }],
    }),
    markAsRead: builder.mutation({
      query: (id) => ({
        url: `${NOTIFICATION_MESSAGE_URL}/${id}/read`,
        method: "PATCH",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patch = patchUnreadNavbarList(dispatch, (items) => {
          const index = findUnreadItemIndex(items, id);
          if (index >= 0) items.splice(index, 1);
        });
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: (_result, _error, id) => [
        { type: "Notification", id },
        { type: "Notification", id: "LIST" },
      ],
    }),
    markAllAsRead: builder.mutation({
      query: () => ({
        url: `${NOTIFICATION_MESSAGE_URL}/mark-all-read`,
        method: "POST",
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const patch = patchUnreadNavbarList(dispatch, (items) => {
          items.splice(0, items.length);
        });
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: [{ type: "Notification", id: "LIST" }],
    }),
  }),
});

export const {
  useGetNotificationQuery,
  useLazyGetNotificationQuery,
  useRemoveNotificationMutation,
  useRemoveAllNotificationsMutation,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
} = NotificationApiSlice;
